import { Injectable, inject } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { createEffect, ofType } from '@ngneat/effects';
import { TeamActions } from '@data/team/team.actions';
import { TeamStore } from '@data/team/team.store';
import { TeamService } from '@data/team/team.service';
import { HttpUtils } from '@shared/util/http.util';
import { UserQuery } from '@data/user/user.query';
import { TeamWithMembers, TeamWithPrivileges } from '@data/team/team.model';

type StoredTeam = TeamWithPrivileges & TeamWithMembers;

@Injectable({ providedIn: 'root' })
export class TeamEffects {
  private teamStore = inject(TeamStore);
  private teamService = inject(TeamService);
  private userQuery = inject(UserQuery);
  private httpUtils = inject(HttpUtils);

  load = createEffect((actions) =>
    actions.pipe(
      ofType(TeamActions.load),
      switchMap(() => this.userQuery.selectUserWhenTruthy$),
      switchMap(() => this.teamService.get().pipe(this.httpUtils.catchAndPrintError())),
      tap((teams) => {
        const activeTeam = this.userQuery.getValue().activeTeam;
        const loaded = (teams ?? []) as StoredTeam[];
        this.teamStore.set(loaded);
        this.teamStore.setActive(activeTeam ?? loaded[0]?._id);
      }),
    ),
  );

  invite = createEffect((actions) =>
    actions.pipe(
      ofType(TeamActions.invite),
      switchMap((request) =>
        this.teamService.invite(request).pipe(this.httpUtils.catchAndPrintError()),
      ),
      tap((teams) => {
        if (!teams) return;
        this.teamStore.set(teams as unknown as StoredTeam[]);
      }),
    ),
  );
}
